module.exports = __webpack_public_path__ + "img/02logo-tee2021.bea24527.png";